import { machToggleLoadingScreen, machGetUrlParameterByName, machAdjustEmailObfuscation } from "./main";
let svgMapZonesSelector = "#locaux *[id], #Locaux *[id], [id^='Locaux_'] *[id], [id^='locaux_'] *[id]";
let svgMapZonesSelectorSpecific = "#locaux [id], #Locaux [id], [id^='Locaux_'] [id], [id^='locaux_'] [id]";

jQuery(document).ready(function () {
    var allStores = {};
    jQuery("#map-store-details-popup").css("display", "none");
    jQuery(document).on("click", ".close-post-details", function (e) {
        e.preventDefault();
        jQuery("#map-store-details-popup").hide();
    });

    jQuery('button[id^="map-level-"]').each(function () {
        var stores = jQuery(this).data("stores");
        jQuery.extend(allStores, stores);
    });

    for (var key in allStores) {
        var zone = jQuery(svgMapZonesSelector).filter(function () {
            return jQuery(this).attr("id").toLowerCase() == key.toLowerCase();
        });

        zone.addClass("map-has-store");
    }

    // Since it's possible that multiple mall zones can be stacked on top of each other, we need to move the zone that have stores to the forefront
    var mapLevels = jQuery(".map-svg");
    if (mapLevels.length > 0) {
        mapLevels.each(function () {
            var svg = jQuery(this).find("svg");
            if (svg.length > 0) {
                const storeElements = svg.find(".map-has-store");
                // Move the SVG elements to the bottom of their DOM parent, which makes them appear on top of the other SVG elements
                storeElements.each(function () {
                    machPushZoneToFrontOfSvg(jQuery(this));
                });
            }
        });
    }

    // Code needed to move the current mall zone to the forefront on the single stores page map zone. Otherwise, the current mal zone SVG element might be hidden behind the other SVG elements
    jQuery(".current-mall-map-zone").each(function () {
        machPushZoneToFrontOfSvg(jQuery(this));
    });

    var storeId = jQuery("#map").data("active-store");
    var mapLevelId = jQuery("#map").data("active-map");

    if (storeId) {
        machSimulateZoneClick(storeId, mapLevelId, allStores);
    }

    jQuery('button[id^="map-level-"]').on("click", function () {
        var mapLevelId = jQuery(this).attr("id").replace("map-level-", "");
        jQuery('[id^="map-svg-"]').css("display", "none");
        jQuery("#map-svg-" + mapLevelId).css("display", "block");

        jQuery('button[id^="map-level-"]').attr("disabled", false).addClass("transparency").removeClass("selected");
        jQuery(this).attr("disabled", true).removeClass("transparency").addClass("selected");
    });

    jQuery("#store-categories a[data-store-id]").on("click", function (e) {
        jQuery("a[data-store-id]").removeClass("selected").addClass("beige");

        jQuery(svgMapZonesSelectorSpecific).css("fill", "");
        jQuery("#post-details").css("display", "none");

        var storeId = jQuery(this).data("store-id");

        jQuery('a[data-store-id="' + storeId + '"]')
            .removeClass("beige")
            .addClass("selected");

        var zone;
        for (var key in allStores) {
            if (allStores[key] === storeId) {
                zone = jQuery(svgMapZonesSelector).filter(function () {
                    return jQuery(this).attr("id").toLowerCase() == key.toLowerCase();
                });

                break;
            }
        }

        if (!zone) {
            return;
        }

        e.preventDefault();

        if (zone.length > 0) {
            var mapSvgDiv = zone.parents('div[id^="map-svg-"]').first();
            var mapLevelId = mapSvgDiv.attr("id").replace("map-svg-", "");

            jQuery('[id^="map-svg-"]').css("display", "none");
            jQuery("#map-svg-" + mapLevelId).css("display", "block");

            jQuery('button[id^="map-level-"]').attr("disabled", false).addClass("transparency").removeClass("selected");
            jQuery("#map-level-" + mapLevelId)
                .attr("disabled", true)
                .removeClass("transparency")
                .addClass("selected");

            machGetPostIdAndtriggerPostDetails(zone.attr("id"), mapLevelId, allStores);

            machPushZoneToFrontOfSvg(zone);
            zone.css("fill", "#000");
            machScrollToInteractiveMap();
        } else {
            machGetPostDetails(storeId);
        }
    });

    jQuery(svgMapZonesSelectorSpecific).click(function () {
        jQuery("a[data-store-id]").removeClass("selected").addClass("beige");

        jQuery(svgMapZonesSelectorSpecific).css("fill", "");
        jQuery("#post-details").css("display", "none");

        var zoneId = jQuery(this).attr("id");

        if (allStores[zoneId]) {
            var storeId = allStores[zoneId];

            jQuery('a[data-store-id="' + storeId + '"]')
                .removeClass("beige")
                .addClass("selected");

            var mapSvgDiv = jQuery(this).parents('div[id^="map-svg-"]').first();

            var mapLevelId = mapSvgDiv.attr("id").replace("map-svg-", "");

            machGetPostIdAndtriggerPostDetails(zoneId, mapLevelId, allStores);
            machPushZoneToFrontOfSvg(jQuery(this));
            jQuery(this).css("fill", "#000");
        }
    });
});

function machSimulateZoneClick(storeId, mapLevelId, stores) {
    var zone;

    for (var key in stores) {
        if (stores[key] == storeId) {
            zone = jQuery(svgMapZonesSelector).filter(function () {
                return jQuery(this).attr("id").toLowerCase() == key.toLowerCase();
            });
            break;
        }
    }

    if (zone) {
        jQuery(svgMapZonesSelectorSpecific).css("fill", "");
        jQuery("#map-store-details-popup").css("display", "none");

        machGetPostIdAndtriggerPostDetails(zone.attr("id"), mapLevelId, stores);

        zone.css("fill", "#000");

        jQuery('[id^="map-svg-"]').css("display", "none");
        jQuery("#map-svg-" + mapLevelId).css("display", "block");

        jQuery('button[id^="map-level-"]').attr("disabled", false).removeClass("selected");
        jQuery("#map-level-" + mapLevelId)
            .attr("disabled", true)
            .addClass("selected");

        jQuery('a[data-store-id="' + storeId + '"]')
            .removeClass("beige")
            .addClass("selected");

        // timeout
        setTimeout(function () {
            machScrollToInteractiveMap();
        }, 1000);
    }
}

function machGetPostIdAndtriggerPostDetails(zone_id, map_level_id, stores) {
    var post_id = null;
    // Case insensitive lookup
    for (var key in stores) {
        if (key.toLowerCase() === zone_id.toLowerCase()) {
            post_id = stores[key];
            break;
        }
    }
    machGetPostDetails(post_id);
}

function machScrollToInteractiveMap() {
    var $target = jQuery("#map");
    let $mainHeader = jQuery(".main-header-fixed");
    if ($mainHeader.length > 0 && $target.length) {
        jQuery("html, body").animate(
            {
                scrollTop: $target.offset().top - $mainHeader.innerHeight() - 60,
            },
            300
        );
    }
}

function machGetPostDetails(post_id) {
    jQuery.ajax({
        url: backendInfo.ajaxurl,
        type: "POST",
        data: {
            action: "mach_retrieve_store_preview_html",
            store_id: post_id,
        },
        beforeSend: function () {
            machToggleLoadingScreen();
        },
        success: function (result) {
            let data = null;
            // check if result is a string before parsing it
            if (typeof result === "string") {
                data = JSON.parse(result);
            } else {
                console.log("An error occured while retrieving the store preview HTML");
                machToggleLoadingScreen();
                return;
            }

            if (data.preview_html) {
                jQuery("#map-store-details-popup").html(data.preview_html);
                jQuery("#map-store-details-popup").show();
            }

            machAdjustEmailObfuscation();
            machToggleLoadingScreen();
        },
    });
}

function machPushZoneToFrontOfSvg(zone) {
    const parent = zone.parent();
    parent.append(zone);
}
